module.exports = __webpack_public_path__ + "img/session3_1.8cdb69b3.png";